import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api/axios";
import ProjectForm from "../../components/forms/ProjectForm";

export default function ProjectModify() {
  const user = JSON.parse(localStorage.getItem("user"));
  const isSuperuser = user?.is_superuser;
  
  const projectId = localStorage.getItem("projectId");
  const [project, setProject] = useState(null);
  

  useEffect(() => {
    if (!isSuperuser) {
      return <p className="p-6 text-red-600">접근 권한이 없습니다.</p>;
    }
    async function fetchProject() {
      try {
        const res = await api.get(`/project/info/${projectId}/`);
        setProject(res.data);
      } catch (err) {
        console.error("프로젝트 불러오기 실패:", err);
      }
    }
    fetchProject();
  }, [projectId]);

  return (
      <div className="p-6">
        <h1 className="text-xl font-semibold">프로젝트 수정</h1>
        <p className="text-gray-600 mb-8">수정할 프로젝트 정보를 입력해 주세요.</p>
        {project ? (
          <ProjectForm initialData={project} isModify={true} />
        ) : (
          <p>프로젝트 정보를 불러오는 중입니다...</p>
        )}
      </div>
    );
  }